
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
  filters: {},
})
export default class VariantCallsLaunch extends Vue {}
